// thrux-external-links.js — Device-Aware External Link Targets (Pattern #22).
//
// Elements with `data-external-link` get `target="_blank"` only on viewports
// >= 768px. Mobile users navigate back via the OS back button — new tabs on
// touch devices create unnecessary tab-management friction. Re-runs on resize
// (debounced 250ms) so iPad rotation and browser-window resize handle cleanly.
//
// Always pair `data-external-link` with `rel="noopener noreferrer"` in the
// source HTML; the rel is independent of viewport and shouldn't change.

(function () {
  var DESKTOP_MIN = 768;

  function applyTargets() {
    var isDesktop = window.innerWidth >= DESKTOP_MIN;
    var links = document.querySelectorAll('[data-external-link]');
    for (var i = 0; i < links.length; i++) {
      if (isDesktop) {
        links[i].setAttribute('target', '_blank');
      } else {
        links[i].removeAttribute('target');
      }
    }
  }

  applyTargets();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyTargets, 250);
  }, { passive: true });
})();
